import { ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS, AdminManagementCompaniesService } from "@/service/api/admin-management-companies";
import useOptionsQuery from "./useOptionsQuery";
import { FilterItem } from "../../filters";
import { AdminManagementCompanyManagerUserSortField } from "../../types/ManagerUsers.enum";
import { ListAdminManagementCompaniesManagerUsersDto } from "@/service/dto/admin-management-companies";

interface UseManagementCompanyManagerUsersParams {
  managementCompanyId: string;
  params?: ListAdminManagementCompaniesManagerUsersDto;
  currentValue?: FilterItem;
  enabled?: boolean;
}

const useManagementCompanyManagerUsers = ({ managementCompanyId, params, currentValue, enabled }: UseManagementCompanyManagerUsersParams) =>
  useOptionsQuery(
    [ADMIN_MANAGEMENT_COMPANIES_ENDPOINTS.GET_MANAGER_USERS(managementCompanyId), params],
    (page, search) =>
      AdminManagementCompaniesService.getManagerUsers(managementCompanyId, {
        sortBy: AdminManagementCompanyManagerUserSortField.NAME,
        sortOrder: "asc",
        ...params,
        page,
        search,
      }),
    (page) => page.values.map((managerUser) => ({ value: managerUser.id, label: managerUser.name })),
    (lastPage) => (lastPage.metadata.currentPage < lastPage.metadata.totalPages ? lastPage.metadata.currentPage + 1 : undefined),
    "Erro ao carregar representantes.",
    currentValue,
    enabled,
  );

export default useManagementCompanyManagerUsers;
